/* ========================================================================
   HERMES LUZ LED v1 — Hogar Nocturno Inteligente · Domótica Cálida
   Anim set: preloader carga USB 0→100 · BlurText · letter reveal ·
             MOTION-DETECT sensor reveal · warm/cool variant tint ·
             count-up · fade-rise stagger · variant sync · anti-spy ·
             desktop-block · Releasit integration · sticky CTA
   ======================================================================== */
(function () {
  'use strict';

  var $  = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  var section = $('.hm-led');
  if (!section) return;

  var isTouch = ('ontouchstart' in window) || (navigator.maxTouchPoints > 0);
  if (isTouch) document.body.classList.add('is-touch');

  /* ── 0) DESKTOP BLOCK + ANTI-SPY ─────────────────────────────── */
  var caught = $('.hm-led-caught');

  function isDesktop() {
    return (
      window.matchMedia('(min-width: 1024px)').matches ||
      (window.matchMedia('(hover: hover) and (pointer: fine)').matches && !isTouch)
    );
  }
  function showCaught(mode) {
    if (!caught) return;
    caught.classList.remove('is-mode-spy', 'is-mode-desktop');
    caught.classList.add('is-active', 'is-mode-' + mode);
  }

  if (section.classList.contains('hm-led--desktop-block') && isDesktop()) {
    showCaught('desktop');
    return; // short-circuit — no further init on blocked desktop
  }

  if (section.classList.contains('hm-led--anti-spy')) {
    document.addEventListener('contextmenu', function (e) { e.preventDefault(); showCaught('spy'); });
    document.addEventListener('keydown', function (e) {
      var key = (e.key || '').toLowerCase();
      if (key === 'f12') { e.preventDefault(); showCaught('spy'); return; }
      if ((e.ctrlKey || e.metaKey) && e.shiftKey && (key === 'i' || key === 'j' || key === 'c')) { e.preventDefault(); showCaught('spy'); return; }
      if ((e.ctrlKey || e.metaKey) && (key === 'u' || key === 's' || key === 'p')) { e.preventDefault(); showCaught('spy'); return; }
    });
    setInterval(function () {
      var delta = Math.abs(window.outerWidth - window.innerWidth) + Math.abs(window.outerHeight - window.innerHeight);
      if (delta > 200) showCaught('spy');
    }, 1500);
    $$('.hm-led img, .hm-led video').forEach(function (el) {
      el.setAttribute('draggable', 'false');
      el.addEventListener('dragstart', function (e) { e.preventDefault(); });
    });
  }

  /* ── 1) PRELOADER carga USB 0 → 100 % + rotating words ───────── */
  (function preloader() {
    var pre = $('#hm-led-preloader'), ctr = $('#hm-led-counter'), bar = $('#hm-led-bar'), wrap = $('#hm-led-words');
    if (!pre || !ctr || !bar) return;
    var target = 100, duration = 2000, start = performance.now();
    function tick(t) {
      var p = Math.min(1, (t - start) / duration);
      var ease = 1 - Math.pow(1 - p, 3);
      ctr.textContent = Math.floor(ease * target);
      bar.style.width = (ease * 100) + '%';
      if (p < 1) requestAnimationFrame(tick);
      else setTimeout(function () { pre.classList.add('is-done'); }, 320);
    }
    requestAnimationFrame(tick);
    if (wrap) {
      var pwords = $$('.hm-led-pw', wrap), idx = 0;
      setInterval(function () {
        pwords[idx].classList.remove('active');
        idx = (idx + 1) % pwords.length;
        pwords[idx].classList.add('active');
      }, 460);
    }
  })();

  /* ── 2) BLUR-TEXT word-by-word (hero headline) ───────────────── */
  (function blurText() {
    $$('.hm-led-blur-text').forEach(function (el) {
      var src = el.getAttribute('data-blur-text') || '';
      el.textContent = '';
      src.split(/\s+/).filter(Boolean).forEach(function (w, i) {
        var span = document.createElement('span');
        span.className = 'hm-led-blur-text__word';
        span.style.setProperty('--d', (0.15 + i * 0.10) + 's');
        span.textContent = w;
        el.appendChild(span);
      });
    });
    setTimeout(function () { $$('.hm-led-blur-text__word').forEach(function (w) { w.classList.add('is-in'); }); }, 820);
  })();

  /* ── 3) LETTER-BY-LETTER reveal (pull-quote) ─────────────────── */
  (function letterReveal() {
    $$('[data-letter-reveal]').forEach(function (el) {
      var src = el.getAttribute('data-source') || '';
      el.innerHTML = '';
      var rx = /(<em>[^<]*<\/em>)|(\S)|(\s+)/g, m, i = 0;
      while ((m = rx.exec(src)) !== null) {
        if (m[1]) {
          var emTxt = m[1].replace(/<\/?em>/g, ''), em = document.createElement('em');
          for (var k = 0; k < emTxt.length; k++) {
            var ch = emTxt[k];
            if (ch === ' ') { em.appendChild(document.createTextNode(' ')); continue; }
            var s = document.createElement('span');
            s.className = 'hm-led-letter'; s.style.setProperty('--d', (i * 0.018) + 's'); s.textContent = ch;
            em.appendChild(s); i++;
          }
          el.appendChild(em);
        } else if (m[2]) {
          var sp = document.createElement('span');
          sp.className = 'hm-led-letter'; sp.style.setProperty('--d', (i * 0.018) + 's'); sp.textContent = m[2];
          el.appendChild(sp); i++;
        } else if (m[3]) { el.appendChild(document.createTextNode(m[3])); }
      }
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) { $$('.hm-led-letter', el).forEach(function (l) { l.classList.add('is-in'); }); io.disconnect(); }
        });
      }, { threshold: 0.4 });
      io.observe(el);
    });
  })();

  /* ── 4) MOTION-DETECT — sensor reveal (la luz te sigue) ──────── */
  (function motionDetect() {
    var stage = $('[data-hm-led-motion]');
    if (!stage) return;
    var idle = true, idleT = 0, raf;
    function setPos(xPct, yPct) {
      stage.style.setProperty('--lx', xPct + '%');
      stage.style.setProperty('--ly', yPct + '%');
    }
    setPos(50, 55);
    /* idle: el "haz" de luz pasea solo (como si el sensor barriera) hasta que el usuario toca */
    function idleLoop(t) {
      if (!idle) return;
      idleT = t / 1000;
      var x = 50 + Math.sin(idleT * 0.5) * 28;
      var y = 55 + Math.cos(idleT * 0.34) * 14;
      setPos(x, y);
      raf = requestAnimationFrame(idleLoop);
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) { stage.classList.add('is-on'); raf = requestAnimationFrame(idleLoop); }
        else { cancelAnimationFrame(raf); }
      });
    }, { threshold: 0.3 });
    io.observe(stage);

    function fromEvent(clientX, clientY) {
      idle = false;
      var r = stage.getBoundingClientRect();
      var x = ((clientX - r.left) / r.width) * 100;
      var y = ((clientY - r.top) / r.height) * 100;
      setPos(Math.max(0, Math.min(100, x)), Math.max(0, Math.min(100, y)));
    }
    stage.addEventListener('mousemove', function (e) { fromEvent(e.clientX, e.clientY); });
    stage.addEventListener('touchstart', function (e) { var t = e.touches[0]; if (t) fromEvent(t.clientX, t.clientY); }, { passive: true });
    stage.addEventListener('touchmove', function (e) { var t = e.touches[0]; if (t) fromEvent(t.clientX, t.clientY); }, { passive: true });
    stage.addEventListener('mouseleave', function () { idle = true; requestAnimationFrame(idleLoop); });
  })();

  /* ── 5) COUNT-UP stats ───────────────────────────────────────── */
  (function countUp() {
    $$('.hm-led-stat__num').forEach(function (el) {
      var target = parseFloat(el.getAttribute('data-target') || '0');
      var suffix = el.getAttribute('data-suffix') || '';
      var prefix = el.getAttribute('data-prefix') || '';
      if (isNaN(target) || target <= 0) return;
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var dur = 1500, start = performance.now();
          function tick(t) {
            var p = Math.min(1, (t - start) / dur), ease = 1 - Math.pow(1 - p, 3);
            el.textContent = prefix + Math.floor(ease * target) + suffix;
            if (p < 1) requestAnimationFrame(tick); else el.textContent = prefix + target + suffix;
          }
          requestAnimationFrame(tick);
          entry.target.classList.add('is-in');
          io.disconnect();
        });
      }, { threshold: 0.5 });
      io.observe(el);
    });
  })();

  /* ── 6) FADE-RISE stagger ────────────────────────────────────── */
  (function fadeRise() {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) { entry.target.classList.add('is-in'); io.unobserve(entry.target); }
      });
    }, { threshold: 0.16 });
    $$('.hm-led-stat, .hm-led-step, .hm-led-bento__cell, .hm-led-parallax__block').forEach(function (el, i) {
      el.style.setProperty('--sd', (i % 4 * 0.08) + 's');
      io.observe(el);
    });
  })();

  /* ── 7) VARIANT SELECTOR sync + warm/cool tint demo ──────────── */
  (function variantSync() {
    var wrap = $('[data-hm-led-variants]');
    var hero = $('#hm-led-hero');
    if (!wrap) return;
    var jsonEl = $('[data-hm-led-variants-json]', wrap), variants = [];
    try { variants = JSON.parse(jsonEl.textContent); } catch (e) {}
    var groups = $$('.hm-led-hero__variant-options', wrap);
    var selected = new Array(groups.length);
    groups.forEach(function (grp, i) {
      var act = $('.hm-led-variant-opt--active', grp);
      selected[i] = act ? act.getAttribute('data-option-value') : null;
    });
    function formatCOP(cents) { return '$' + (cents / 100).toLocaleString('es-CO', { maximumFractionDigits: 0 }); }
    function findVariant() {
      return variants.find(function (v) {
        var o = [v.option1, v.option2, v.option3];
        for (var i = 0; i < groups.length; i++) { if (selected[i] && o[i] !== selected[i]) return false; }
        return true;
      });
    }
    function tintFromValue(val) {
      if (!hero) return;
      var v = (val || '').toLowerCase();
      if (v.indexOf('cálid') > -1 || v.indexOf('calid') > -1 || v.indexOf('warm') > -1) hero.setAttribute('data-temp', 'warm');
      else if (v.indexOf('blanc') > -1 || v.indexOf('frí') > -1 || v.indexOf('cool') > -1 || v.indexOf('white') > -1) hero.setAttribute('data-temp', 'cool');
    }
    function apply(v) {
      if (!v) return;
      var inp = $('[data-hm-led-variant-input]'); if (inp) inp.value = v.id;
      if (typeof v.price === 'number') {
        var p = formatCOP(v.price);
        [$('.hm-led-hero__price-now'), $('.hm-led-final__now'), $('.hm-led-sticky-cta__now')].forEach(function (e) { if (e) e.textContent = p; });
      }
      window._RSI_COD_FORM_OVERWRITE_ATC_ITEMS = [{ id: v.id, quantity: 1 }];
    }
    /* el tinte solo aparece al interactuar — el hero arranca natural */
    groups.forEach(function (grp, gi) {
      $$('.hm-led-variant-opt', grp).forEach(function (btn) {
        btn.addEventListener('click', function () {
          $$('.hm-led-variant-opt', grp).forEach(function (b) { b.classList.remove('hm-led-variant-opt--active'); });
          btn.classList.add('hm-led-variant-opt--active');
          selected[gi] = btn.getAttribute('data-option-value');
          if (gi === 0) tintFromValue(selected[gi]);
          apply(findVariant());
        });
      });
    });
  })();

  /* ── 8) RELEASIT INTEGRATION ─────────────────────────────────── */
  (function releasit() {
    var heroCta = $('[data-hm-led-cta-proxy]');
    var mainCta = $('[data-hm-led-main-cta]');
    if (heroCta) {
      heroCta.addEventListener('click', function (e) {
        var rsiBtn = document.querySelector('._rsi-buy-now-button:not(._rsi-buy-now-button-floating), #_rsi-buy-now-button-overwrite');
        if (rsiBtn) { e.preventDefault(); rsiBtn.click(); return; }
        if (mainCta) { e.preventDefault(); mainCta.click(); }
      });
    }
    var attempts = 0;
    var poll = setInterval(function () {
      attempts++;
      var rsiBtn = document.querySelector('._rsi-buy-now-button, #_rsi-buy-now-button-overwrite');
      if (rsiBtn) { clearInterval(poll); console.info('[HERMES led-v1] Releasit button detected.'); }
      else if (attempts > 40) { clearInterval(poll); console.warn('[HERMES led-v1] Releasit not detected — check Dropi metafield + dashboard.'); }
    }, 500);
  })();

  /* ── 9) Scroll-hint hide ─────────────────────────────────────── */
  (function scrollHint() {
    var hint = $('.hm-led-hero__scrollhint'); if (!hint) return;
    var hide = function () { if (window.scrollY > 80) { hint.style.opacity = '0'; window.removeEventListener('scroll', hide); } };
    window.addEventListener('scroll', hide, { passive: true });
  })();

  /* ── 10) RELEASIT SUBMIT SKIN (PASO 49.1) ────────────────────── */
  /* Releasit pinta el submit del modal con INLINE STYLES + !important.
     CSS no puede ganarle — lo sobrescribimos vía JS re-seteando el inline
     style con priority 'important' (honey glow + texto negro). */
  (function releasitSubmitSkin() {
    function skin(el) {
      if (!el || el.getAttribute('data-hm-led-skinned') === '1') return;
      el.style.setProperty('background', 'linear-gradient(135deg, #E9B24E, #F7CE83)', 'important');
      el.style.setProperty('background-color', '#F7CE83', 'important');
      el.style.setProperty('color', '#000000', 'important');
      el.style.setProperty('border', '2px solid #FBE3B0', 'important');
      el.style.setProperty('border-radius', '999px', 'important');
      el.style.setProperty('box-shadow', '0 0 28px rgba(247,206,131,0.45), 0 6px 18px rgba(0,0,0,0.25)', 'important');
      el.style.setProperty('font-weight', '700', 'important');
      el.style.setProperty('text-transform', 'uppercase', 'important');
      el.style.setProperty('letter-spacing', '0.04em', 'important');
      el.style.setProperty('min-height', '54px', 'important');
      el.setAttribute('data-hm-led-skinned', '1');
      $$('*', el).forEach(function (n) {
        if (n.tagName === 'IMG' || n.tagName === 'SVG') return;
        n.style.setProperty('color', '#000000', 'important');
      });
    }
    function sweep() {
      $$('._rsi-modal-submit-button, [class*="_rsi"][class*="submit-button"]:not([class*="build-block"]), [class*="_rsi-build-block-submit"] button').forEach(skin);
    }
    sweep();
    var mo = new MutationObserver(function () { sweep(); });
    mo.observe(document.body, { childList: true, subtree: true });
    var rp = setInterval(sweep, 800);
    setTimeout(function () { clearInterval(rp); }, 40000);
    document.addEventListener('click', function () { setTimeout(sweep, 300); setTimeout(sweep, 900); }, true);
  })();

  /* ── 11) STICKY CTA bottom (mobile) ──────────────────────────── */
  (function stickyCta() {
    var sticky = $('.hm-led-sticky-cta'), heroCta = $('.hm-led-hero__cta'), finalSec = $('#hm-led-cta-final');
    if (!sticky || !heroCta) return;
    function killFloating() {
      $$('[class*="_rsi-buy-now"][class*="floating"], ._rsi-buy-now-button-floating, [class*="_rsi-floating"]').forEach(function (el) {
        el.style.display = 'none'; el.style.visibility = 'hidden'; el.style.opacity = '0'; el.style.pointerEvents = 'none';
      });
    }
    killFloating();
    var kp = setInterval(killFloating, 500); setTimeout(function () { clearInterval(kp); }, 24000);

    var ioHero = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) { sticky.classList.toggle('is-visible', !entry.isIntersecting); });
    }, { threshold: 0.1 });
    ioHero.observe(heroCta);

    if (finalSec) {
      var ioFinal = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) { section.classList.toggle('is-final-cta-visible', entry.isIntersecting); });
      }, { threshold: 0.15, rootMargin: '0px 0px -40% 0px' });
      ioFinal.observe(finalSec);
    }

    var btn = $('.hm-led-sticky-cta__btn', sticky);
    if (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var rsiBtn = document.querySelector('._rsi-buy-now-button:not(._rsi-buy-now-button-floating), #_rsi-buy-now-button-overwrite');
        if (rsiBtn) { rsiBtn.click(); return; }
        var mainCta = document.querySelector('[data-hm-led-main-cta]');
        if (mainCta) { mainCta.click(); return; }
        finalSec && finalSec.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    }
  })();

  console.info('[HERMES led-v1] Section initialized.');
})();
